<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="login login-1 d-flex flex-column flex-lg-row flex-column-fluid bg-white"
      :class="{
        'login-signin-on': this.state == 'signin',
        'login-forgot-on': this.state == 'forgot'
      }"
      id="kt_login"
    >
      <!--begin::Content-->
      <div
        class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto"
      >
        <div class="d-flex flex-column-fluid flex-center">
          <!--begin::Signin-->
          <div class="login-form login-signin">
            <form
              class="form"
              novalidate="novalidate"
              id="kt_login_signin_form"
            >
              <div class="pb-5 pt-lg-0 pt-5">
                <h3
                  class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg"
                  style="
                    font-size: 1.6rem !important;
                    font-weight: 500 !important;
                    color: #482182 !important;
                  "
                >
                  Olá! Vamos nos conectar? :)
                </h3>
              </div>
              <div class="form-group">
                <label
                  class="font-size-h6 font-weight-bolder text-dark"
                  style="
                    color: #a7a7a7 !important;
                    font-size: 1rem !important;
                    font-weight: 400 !important;
                  "
                  >E-mail</label
                >
                <div
                  id="example-input-group-1"
                  label=""
                  label-for="example-input-1"
                >
                  <input
                    class="form-control form-control-solid h-auto py-7 px-6 rounded-lg"
                    type="text"
                    name="email"
                    ref="email"
                    placeholder="Email"
                    v-model="form.email"
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="d-flex justify-content-between mt-n7">
                  <label
                    class="font-size-h6 font-weight-bolder text-dark pt-5"
                    style="
                      color: #a7a7a7 !important;
                      font-size: 1rem !important;
                      font-weight: 400 !important;
                    "
                    >Senha</label
                  >
                </div>
                <div
                  id="example-input-group-2"
                  label=""
                  label-for="example-input-2"
                >
                  <input
                    class="form-control form-control-solid h-auto py-7 px-6 rounded-lg mb-2"
                    type="password"
                    name="senha"
                    ref="senha"
                    placeholder="Senha"
                    v-model="form.senha"
                    autocomplete="off"
                  />
                  <a
                    class="text-primary font-weight-bolder text-hover-primary pt-5"
                    id="kt_login_forgot"
                    style="
                      font-weight: 400 !important;
                      color: #482182 !important;
                      text-decoration: underline;
                      cursor: pointer;
                    "
                    @click="showForm('forgot')"
                    >Esqueceu sua senha ?</a
                  >
                </div>
              </div>
              <div class="pb-lg-0 pb-5">
                <button
                  ref="kt_login_signin_submit"
                  class="btn btn-primary font-weight-bolder font-size-h6 px-15 py-4 my-3 mr-3 w-100"
                  alt="Matheus Rodrigues and MV Best Developer :P"
                  style="
                    height: 46px !important;
                    background-color: #482182;
                    border: none;
                  "
                >
                  Entrar
                </button>
              </div>
              <p class="text-muted" style="font-size: 0.8rem">
                Este site é protegido pelo reCAPTCHA. A
                <a
                  href="https://policies.google.com/privacy"
                  style="color: #482182 !important"
                  >Política de Privacidade</a
                >
                e os
                <a
                  href="https://policies.google.com/terms"
                  style="color: #482182 !important"
                  >Termos de Serviço</a
                >
                do Google se aplicam.
              </p>
            </form>
          </div>
          <!--end::Signin-->
          <!--begin::Forgot-->
          <div class="login-form login-forgot">
            <!--begin::Form-->
            <form
              class="form"
              novalidate="novalidate"
              id="kt_login_forgot_form"
              ref="kt_login_forgot_form"
            >
              <div class="pb-6 pt-lg-0 pt-5">
                <h3
                  class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg"
                  style="
                    font-size: 1.6rem !important;
                    font-weight: 500 !important;
                    color: #482182 !important;
                  "
                >
                  Recuperação de senha
                </h3>
                <p
                  class="text-muted font-weight-bold font-size-h5"
                  style="color: #a7a7a7 !important; font-weight: 500 !important"
                >
                  Informe seu email para recuperar sua senha.
                </p>
              </div>
              <div class="form-group">
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                  type="email"
                  placeholder="Email"
                  name="email"
                  v-model="formResetPassword.email"
                  autocomplete="off"
                />
              </div>
              <div class="form-group d-flex pb-lg-0">
                <button
                  type="submit"
                  id="kt_login_forgot_submit"
                  ref="kt_login_forgot_submit"
                  class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-3 my-3 mr-4 w-100"
                  style="background-color: #482182; border: none"
                >
                  Enviar
                </button>
                <button
                  type="button"
                  id="kt_login_forgot_cancel"
                  class="btn btn-light-primary font-weight-bolder font-size-h6 px-8 py-3 my-3 w-100"
                  @click="showForm('signin')"
                  style="
                    border: 1px solid #a7a7a7;
                    color: #482182;
                    background-color: white;
                  "
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
          <!--end::Forgot-->
        </div>
      </div>
      <!--end::Content-->
      <!--begin::Aside-->
      <div
        class="login-aside diagonal-aside d-flex flex-column flex-row-auto justify-content-center"
        style="background-color: #ff7900"
      >
        <a href="#" class="text-center mb-10">
          <img
            src="media/comunicante/logo-wellon-login.png"
            style="height: 85vh"
            alt=""
          />
        </a>
        <!-- <h3
            class="font-weight-bolder text-center font-size-h4 font-size-h1-lg"
            style="color: #356a7c"
          >
            Soluções inteligentes para atendimento e relacionamento com o
            cliente!
          </h3> -->
        <!-- <div
          class="aside-img d-flex flex-row-fluid bgi-no-repeat bgi-position-y-bottom bgi-position-x-center"
          :style="{ backgroundImage: `url(${backgroundImage})` }"
        ></div> -->
      </div>
      <!--begin::Aside-->
    </div>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";

import KTUtil from "@/assets/js/components/util";
import { mapGetters } from "vuex";
import {
  LOGIN,
  LOGOUT,
  RESET_PASSWORD
} from "@/core/services/store/auth.module";
import Swal from "sweetalert2";

export default {
  name: "login-1",
  data() {
    return {
      state: "signin",
      form: {
        email: "",
        senha: "",
        token: ""
      },

      formResetPassword: {
        email: ""
      },
      windowWidth: 0
    };
  },
  computed: {
    ...mapGetters(["validatorErrors"]),

    backgroundImage() {
      return process.env.BASE_URL + "media/comunicante/bg-login.svg";
    }
  },
  mounted() {
    this.windowWidth = window.innerWidth;
    const signin_form = KTUtil.getById("kt_login_signin_form");
    const forgot_form = KTUtil.getById("kt_login_forgot_form");
    this.limparCacheFiltrosCampanha();

    this.fv = formValidation(signin_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: "Campo obrigatório."
            },
            emailAddress: {
              message: "Informe um email válido."
            },
            blank: {}
          }
        },
        senha: {
          validators: {
            notEmpty: {
              message: "Campo obrigatório."
            },
            blank: {}
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap()
      }
    });

    this.fv1 = formValidation(forgot_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: "Campo obrigatório."
            },
            emailAddress: {
              message: "Informe um email válido."
            },
            blank: {}
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap()
      }
    });

    this.fv.on("core.form.valid", async () => {
      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      await this.$recaptchaLoaded();
      this.form.token = await this.$recaptcha("login");

      this.$store
        .dispatch(LOGIN, this.form)
        .then(() => {
          this.$router.push("/");
        })
        .catch(() => {
          for (const error in this.validatorErrors) {
            this.fv
              .updateValidatorOption(
                error,
                "blank",
                "message",
                this.validatorErrors[error]
              )
              .updateFieldStatus(error, "Invalid", "blank");
          }
        })
        .finally(() => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    });

    this.fv.on("core.form.invalid", () => {
      Swal.fire({
        title: "",
        text: "Verifique suas credenciais!",
        icon: "error",
        confirmButtonClass: "btn btn-secondary",
        heightAuto: false
      });
    });

    this.fv1.on("core.form.valid", () => {
      const submitButton = this.$refs["kt_login_forgot_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      this.$store
        .dispatch(RESET_PASSWORD, this.formResetPassword)
        .then(() => {
          this.state = "signin";
          this.form = {
            email: "",
            senha: ""
          };
          this.formResetPassword = {
            email: ""
          };

          Swal.fire({
            title: "MENSAGEM: ",
            text: "Um link para recuperação de senha foi enviado para você, verifique seu email!",
            icon: "success",
            confirmButtonClass: "btn btn-success",
            heightAuto: false
          });
        })
        .catch(() => {
          for (const error in this.validatorErrors) {
            this.fv
              .updateValidatorOption(
                error,
                "blank",
                "message",
                this.validatorErrors[error]
              )
              .updateFieldStatus(error, "Invalid", "blank");
          }
        })
        .finally(() => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    });
  },
  methods: {
    showForm(form) {
      this.state = form;
      var form_name = "kt_login_" + form + "_form";
      KTUtil.animateClass(
        KTUtil.getById(form_name),
        "animate__animated animate__backInUp"
      );
    },
    limparCacheFiltrosCampanha() {
      // Clear from localStorage (filtrosCampanha)
      localStorage.removeItem("filtrosCampanha");
    }
  }
};
</script>

<style scoped>
.diagonal-aside {
  margin-top: -25em;
  margin-left: -5em;
  background: #ffffff;
  overflow: hidden;
  -webkit-transform: skew(-16deg) translateX(-70px);
  -ms-transform: skew(-16deg) translateX(-70px);
  transform: skew(16deg) translateX(100px);
  left: 0;
}

.diagonal-aside img {
  width: 75%;
  margin-left: -20em;
  margin-top: 28em;
  -webkit-transform: skew(16deg) translateX(140px);
  -ms-transform: skew(16deg) translateX(140px);
  transform: skew(-16deg) translateX(40px);
  left: 0;
}

input {
  border: 1px solid #a7a7a7 !important;
  border-radius: 5px !important;
  background-color: white !important;
  padding: 8px 16px !important;
  height: 46px !important;
}

@media screen and (max-width: 768px) {
  .diagonal-aside {
    display: none;
  }
}
</style>
